import { Component } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HeadshotUploadService } from './headshot-upload.service';
import { environment } from 'src/environments/environment';
import { SessionService } from '../Services/session.service';
import { BrowserSupportService } from '../browser-support/browser-support.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { IdUploadService } from '../id-upload/id-upload.service';
import { dashboardRoute } from '../route-names';
import { DialogService, DialogType } from '../Services/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { ElectorDataService } from '../Services/elector-data.service';
import { MteService } from '../Services/mte.service';
import { ApiService, headshotUploadAPI } from '../api/api.service';
import { FaceLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';

@Component({
    selector: 'app-headshot-upload',
    templateUrl: './headshot-upload.component.html',
    styleUrls: ['./headshot-upload.component.scss'],
    standalone: false
})
export class HeadshotUploadComponent {

  clientWebURL:string = environment.clientWebURL;

  headshotUploadState = this.headshotUploadService.getState();

  readonly isOpen = new BehaviorSubject(false);

  routeName = "";
  showTips = true
  faceLandmarker!: FaceLandmarker;

  submit(event: any) {
    event.preventDefault();
    this.isOpen.next(true);
    this.sessionService.refreshSession();
  }
  public get triggerObservable(): Observable<void> {
    return this.headshotUploadState.trigger.asObservable();
  }

  dialogTitle: string = '';
  dialogText: string = '';
  displaySpinner: boolean = false;

  constructor(
    readonly headshotUploadService: HeadshotUploadService,
    readonly sessionService: SessionService,
    readonly browserSupportService: BrowserSupportService,
    readonly router: Router,
    private http: HttpClient,
    private readonly idUploadService: IdUploadService,
    private readonly dialogService: DialogService,
    private readonly dialog: MatDialog,
    private readonly userService: ElectorDataService,
    private readonly mteService: MteService,
    private readonly apiService: ApiService
  ) {
    this.routeName = this.router.url;
  }
  
  async ngOnInit(): Promise<void> {
    try {
      await this.initializeFaceLandmarker();
    } catch (error) {
      console.error('Error Loading Model', error);
    }
  }


  goToDetection(){
    this.headshotUploadService.showTips = false
  }

  processImage(image: string){
    if(image){
      this.displaySpinner = true;
      const base64Headshot = image.replace(/^data:image\/[a-z]+;base64,/, '');
      const blob = this.idUploadService.b64toBlob(base64Headshot, 'image/jpeg');
      let headers = new HttpHeaders().set('Content-Type', 'image/jpeg');
      if (this.mteService.useMte) {
        this.apiService.postWithHandshakeCheck<any>(
          headshotUploadAPI,
          base64Headshot,
          headers
        ).subscribe({
          next: () => {
            this.handleNext();
          },
          error: (err) => {
            this.handleError(err);
          }
        });
      } else {
        this.http.post<HttpResponse<any>>(headshotUploadAPI, blob, { headers, withCredentials: true }).subscribe({
          next: () => {
            this.handleNext();
          },
          error: (err) => {
            this.handleError(err);
          }
        });
      }
    } else {
      throw new Error("No photo.");
    }
  }

  handleNext() {
    this.userService.idvStatus.set('PENDING');
    this.displaySpinner = false;
    this.dialogTitle = $localize`Success!`;
    this.dialogText = $localize`Your photo upload was successful. Once your ID verification is successful, you will be able to access your ballot. Please note that this can take up to 24 hrs.`;
    this.dialogService.openDialog(DialogType.SUCCESS, this.dialogTitle, this.dialogText);
    this.dialog.afterAllClosed.subscribe({
      next: () => {
        //this.registrationService.registered = true;
        this.router.navigate(dashboardRoute);
      },
      error: ()=>{}
    })
    setTimeout(() => {
      this.dialog.closeAll();
      //this.registrationService.registered = true;
      this.router.navigate(dashboardRoute);
    }, 5000);
  }

  handleError(err: any) {
    this.displaySpinner = false;
    this.dialogTitle = $localize`Error`;
    if (err.status === 401) {
      this.dialogText = $localize`We could not establish your identity. Please start the registration process again.`;
    } else {
      this.dialogText = $localize`Please check your network connection and try again.`;
    }
    this.dialogService.openDialog(DialogType.ERROR, this.dialogTitle, this.dialogText);
    this.headshotUploadService.showTips = true;
    this.dialog.afterAllClosed.subscribe({
      next: () => {
        this.headshotUploadService.showTips = true;
      },
      error: ()=>{}
    });
    setTimeout(() => {
      this.dialog.closeAll();
      this.headshotUploadService.showTips = true;
    }, 5000);
  }

  private async initializeFaceLandmarker(): Promise<void> {
    const filesetResolver = await FilesetResolver.forVisionTasks(
      './assets/model/tasks-vision/0-10-3/wasm'
    );
    this.faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
      baseOptions: {
        modelAssetPath: `./assets/model/tasks-vision/0-10-3/face_landmarker.task`,
        delegate: 'GPU',
      },
      outputFaceBlendshapes: true,
      runningMode: 'VIDEO',
      numFaces: 1,
    });
  }
  
}
